// @flow
import GoalsCreate from "./GoalsCreate";

export default GoalsCreate;
